// Growl Alerts
document.getElementById('growl1').addEventListener('click', () => {
	ui.alert('<div class="alert alertSuccess"><h4 class="alertTitle">Successfully Deleted</h4><p>Closes after 4 seconds.</p></div>', {
		display: 'notification',
		duration: 4000
	});
});
document.getElementById('growl2').addEventListener('click', () => {
	ui.alert('<div class="alert alertNoIcon alertCloseable"><h4 class="alertTitle">Could not save</h4><p>Stays open.</p></div>', {
		display: 'notification',
		closeable: true
	});
});
// Info Alert
ui.alert('#info-alert1', {
	closeable: true
});
// Removable Alert
ui.alert('#alert-example2', {
	removable: true,
	closeable: true
});
// Sitewide Alert
const siteWide = ui.alert('<p class="alert alertSitewide"><strong>This is a sitewide alert.</strong> Only one should be visible at a time.  It should be placed as an immediate child to the document body.</p>', {
	display: 'sitewide',
	closeable: true
});
document.body.insertBefore(siteWide.element, document.body.firstChild);
// Overlay Alert
const overlayExample = ui.alert('#overlayExample', {
	display: 'overlay',
	closeable: true,
	open: false
});
document.getElementById('showOverlayAlert').addEventListener('click', () => {
	overlayExample.open();
});
// Section Alert
ui.alert('#section-alert', {
	closeable: true
});

// Toast Notifications
document.getElementById('toastBottom').addEventListener('click', e => {
	const triggerButton = e.target;
	triggerButton.classList.add('disabled');
	const instance = ui.alert('<div class="alert alertSuccess" id="contextualAlert">Node deleted. <button class="undoBtn link bold" type="button">Undo</button></div>', {
		display: 'notification',
		closeable: false,
		duration: 0,
		animation: true,
		location: 'bottomRight',
		onClose: () => {
			triggerButton.classList.remove('disabled');
		},
		onOpen: () => {
			instance.element.querySelector('.undoBtn').addEventListener('click', () => {
				instance.close();
			});
		}
	});
	const exampleSection = document.getElementById('toast-alert');
	exampleSection.appendChild(instance.element, exampleSection.firstChild);
});
document.getElementById('toastTop').addEventListener('click', e => {
	const triggerButton = e.target;
	triggerButton.classList.add('disabled');
	const instance = ui.alert('<div class="alert alertSuccess" id="contextualAlert">Node successfully deleted. <button class="undoBtn link bold" type="button">Undo</button></div>', {
		animation: true,
		display: 'notification',
		duration: 0,
		location: 'topRight',
		onClose: () => {
			triggerButton.classList.remove('disabled');
		},
		onOpen: () => {
			instance.element.querySelector('.undoBtn').addEventListener('click', () => {
				instance.close();
			});
		}
	});
	const exampleSection = document.getElementById('toast-alert');
	exampleSection.appendChild(instance.element, exampleSection.firstChild);
});



// WEBPACK FOOTER //
// ./src/components/alert/alert.demo.js